import React from 'react';
import PropTypes from 'prop-types';

// Home component serves as the landing page for the Finite Magazine Lifestyle Club
const Home = ({ user, setCurrentView }) => {
  // Handle button clicks with a safeguard for setCurrentView
  const handleViewChange = (view) => {
    if (typeof setCurrentView === 'function') {
      setCurrentView(view);
    } else {
      // Log a detailed error for debugging during development
      console.error(
        `setCurrentView is not a function. Received: ${typeof setCurrentView}. ` +
        `Ensure setCurrentView is passed as a function from the parent component.`
      );
    }
  };

  return (
    <div className="home-container">
      <div className="hero-section">
        <h1>Welcome to Finite Magazine Lifestyle Club</h1>
        <p>Your gateway to exclusive experiences, networking opportunities, and premium lifestyle benefits</p>
        
        {!user ? (
          <div className="auth-buttons">
            <button
              className="btn-primary"
              onClick={() => handleViewChange('login')}
              aria-label="Login to your account"
            >
              Login
            </button>
            <button
              className="btn-secondary"
              onClick={() => handleViewChange('register')}
              aria-label="Register for a new account"
            >
              Register
            </button>
          </div>
        ) : (
          <div className="user-actions">
            <h2>What would you like to do today?</h2>
            <div className="action-buttons">
              <button
                className="btn-primary"
                onClick={() => handleViewChange('member')}
                aria-label="Apply for FMLC Membership"
              >
                Apply for Membership
              </button>
              <button
                className="btn-primary"
                onClick={() => handleViewChange('partner')}
                aria-label="Apply for FMLC Partnership"
              >
                Apply for Partnership
              </button>
            </div>
          </div>
        )}
      </div>
      
      <div className="features-section">
        <h2>Why Join FMLC?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Exclusive Events</h3>
            <p>Access to premium lifestyle events and business occasions</p>
          </div>
          <div className="feature-card">
            <h3>Networking Opportunities</h3>
            <p>Connect with like-minded individuals and businesses</p>
          </div>
          <div className="feature-card">
            <h3>Member Benefits</h3>
            <p>Enjoy special discounts, offers, and funeral cover benefits</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// PropTypes for type checking the component props
Home.propTypes = {
  user: PropTypes.object, // User object, can be null if not authenticated
  setCurrentView: PropTypes.func.isRequired, // Function to set the current view
};

// Default props to prevent undefined errors
Home.defaultProps = {
  user: null,
};

export default Home;